import axios from 'axios';

/**
 * Resolve a bare RM reference (a chip the chat couldn't enrich with a
 * doc_id from the message's entity instances) to its document identity,
 * via the agent's compact summary-lookup tool. Permission-enforced
 * server-side — references the user can't view come back not-found.
 *
 * Returns `{ reference, doc_id, doc_name }` or null (not found / no
 * permission / transport error). Callers fall back to their own
 * affordance (typically a chat lookup) on null.
 */
export async function resolveDocReference(reference) {
    const ref = typeof reference === 'string' ? reference.trim() : '';
    if (!ref) return null;
    try {
        const resp = await axios.post(
            '/agent/tools/get_jobs_summary_by_references/execute',
            { args: { references: [ref] } },
            { headers: { 'X-Atlas-Surface': 'portal' } },
        );
        const jobs = resp.data?.data?.jobs;
        const job = Array.isArray(jobs)
            ? jobs.find((j) => j && j.reference === ref) ?? jobs[0]
            : null;
        const docId = Number(job?.doc_id);
        if (!Number.isFinite(docId) || docId <= 0) return null;
        return { reference: ref, doc_id: docId, doc_name: job.doc_name ?? null };
    } catch {
        return null;
    }
}
